export default __webpack_public_path__ + "static/media/cortina.4c2569ef.jpg";